import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import { className } from "../../../../shared/helpers";
import styles from "./Header.module.scss";

interface HeaderProps
{
    component: IComponent;
    showChildren: boolean;
    sidebarHidden: boolean;
    onShowChildren: (showChildren: boolean) => void;
}

const Header = (props: HeaderProps): ReactElement =>
{
    function onShowChildren(): void
    {
        props.onShowChildren(!props.showChildren);
    }

    return (
        <div className={styles.header}>
            <div className={styles.navigation}>
                {props.component?.parentName && (
                    <Link to={`/dashboard/${props.component.parentId}`}>{props.component.parentName}</Link>
                )}

                {!props.component?.parentName || (
                    <button
                        {...className(styles.childrenButton, { [styles.hiddenForMobile]: props.sidebarHidden })}
                        onClick={onShowChildren}
                    >
                        {props.showChildren
                            ? <i className="material-icons">account_tree</i>
                            : <i className="material-icons">arrow_back</i>
                        }
                    </button>
                )}
            </div>

            <h3 className={styles.heading} title={props.component?.name}>
                {props.component?.name}
            </h3>
        </div>
    );
};

export default Header;
